// src/components/LandingPage.js
import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import Solutions from './Solutions';
import ZigZagFeatures from './ZigZagFeatures';
import Features from './Features';
import Pricing from './Pricing';
import FAQ from './FAQ';
import Footer from './Footer';
import CallToAction from './CallToAction';
import Comparison from './Comparison';

const LandingPage = () => {
  const theme = {
    primary: '#3ba9e1',     
    primaryDark: '#2c8ac0', 
    secondary: '#0f172a',
    navBg: '#132238',       
    navText: '#ffffff',     
    accent: '#f59e0b',      
    success: '#10b981',     
    bgLight: '#f8fafc',     
    bgWhite: '#ffffff',
  };

  return (
    <div style={{ fontFamily: '"Inter", sans-serif', color: theme.secondary, overflowX: 'hidden' }}>
      <Navbar theme={theme} />
      <Hero theme={theme} />
      <Solutions theme={theme} />      
      <ZigZagFeatures theme={theme} /> 
      <Features theme={theme} />
      <Comparison theme={theme} />       
      <Pricing theme={theme} />
      <FAQ theme={theme} />
      <CallToAction theme={theme} />
      <Footer theme={theme} />
    </div>
  );
};

export default LandingPage;